module.exports = ".text-placeholder-default {\n  color: #062b3e !important;\n}\n\n@media (min-width: 768px) {\n  .list-wrapper-icons-bottom {\n    bottom: 55px;\n  }\n}\n\n.research-list-value {\n  font-size: 11px;\n}\n\n.mini-comment {\n  height: 29rem;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/reports/reports.component.css
// module id = ./src/app/feature/main/roles-shared/components/reports/reports.component.css
// module chunks = main